import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  estimatePermissionRoles,
  mediaAdmin,
} from 'src/app/helpers/enums/role-type.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { SidebarState } from 'src/app/state/sidebar.state';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public mediaAdmin: string[] = mediaAdmin;
  public isQueryParams: boolean = false;
  public userData: string = null;
  public role: string = null;
  public estimatePermission: string[] = estimatePermissionRoles();
  public subscriptions: Subscription[] = [];
  public accessToken: string = '';
  public vehicleId: string = '';
  public bodyTypeId: string = '';
  public partsType = [
    'frame',
    'mechanics',
    'major_options',
    'Exterior',
    'Interior',
  ];

  constructor(
    public state: SidebarState,
    public authService: AuthService,
    public sharedService: SharedService,
    public router: Router
  ) {
    this.getUserData();

    this.isQueryParams = this.sharedService.getQueryParamCheck || false;
  }

  ngOnInit(): void {}

  getUserData() {
    const authSub = this.authService.user.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
    });

    this.subscriptions.push(authSub);
  }

  logout() {
    this.state.hide();
    this.authService.Logout();
    this.router.navigate(['/']);
  }
}
